module.exports = __webpack_public_path__ + "img/img6_4.41f41e3b.jpeg";